import React from 'react';
import Navigation from './components/Navigation';
import Home from './components/Home';
import Footer from './components/Footer';
import './App.css';

function App() {
  const navigateToAnchor = (anchor) => {
    const el = document.getElementById(anchor);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <div className="App d-flex flex-column">
      <div className="paper-grain" aria-hidden="true" />
      <Navigation navigateToAnchor={navigateToAnchor} />
      <Home />
      <Footer navigateToAnchor={navigateToAnchor} />
    </div>
  );
}

export default App;
